"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _ExpandableAddon = _interopRequireDefault(require("../../ExpandableAddon"));

function BurnInCaptions(a) {
  var b = a.burnInCaptions,
      c = a.onChangeAddon,
      d = a.disabled,
      e = a.BURN_IN_CAPTIONS;
  return _react["default"].createElement(_ExpandableAddon["default"], {
    options: e,
    addonValue: b,
    title: "Subtitles (Burn-in)",
    subtitle: "English spoken videos only.",
    onChangeAddon: c("BURN_IN_CAPTIONS"),
    disabled: d,
    type: "SINGLE"
  });
}

var _default = (0, _react.memo)(BurnInCaptions);

exports["default"] = _default;